import { CalendarIcon } from "@heroicons/react/outline";
import moment from "moment";

interface PlanCardDateDisplayProps {
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  isNewEnterprisePlan: boolean;
}

export const PlanCardDateDisplay = ({
  currentPeriodStart,
  currentPeriodEnd,
  isNewEnterprisePlan,
}: PlanCardDateDisplayProps) => {
  if (!currentPeriodEnd) {
    return null;
  }

  if (isNewEnterprisePlan) {
    if (!currentPeriodStart) {
      return null;
    }

    const periodStart = moment(currentPeriodStart);
    const periodEnd = moment(currentPeriodEnd);
    const periodDurationMonths = periodEnd.diff(periodStart, "months", true);

    if (periodDurationMonths > 1) {
      return null;
    }

    return (
      <div className="flex items-center gap-1.5 rounded-lg border border-gray-100 bg-gray-50 px-2.5 py-1.5">
        <CalendarIcon className="h-3.5 w-3.5 text-gray-400" />
        <span className="text-xs font-medium text-gray-600">
          {periodStart.format("MMM D")} – {periodEnd.format("MMM D, YYYY")}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 rounded-lg border border-gray-100 bg-gray-50 px-2.5 py-1.5">
      <CalendarIcon className="h-3.5 w-3.5 text-gray-400" />
      <span className="text-xs font-medium text-gray-600">
        Ends on {moment(currentPeriodEnd).format("MMM D, YYYY")}
      </span>
    </div>
  );
};
